// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"8e3e3c4b","380":"e4293c2f","527":"423246e6","787":"d4aba7ab","792":"8377eacb"}[chunkId] + ".chunk.js";
};